// import { API_HOST } from '../../configs/api';
// import { useState, useRef, useEffect } from 'react';
// import axios from 'axios';
// import './AiAssistantPopup.scss';

// // function AiAssistantPopup({ editor }) {
// function AiAssistantPopup({ editor, prompt, setPrompt, code, setCode }) {
//     const [isOpen, setIsOpen] = useState(false);
//     // const [prompt, setPrompt] = useState('');
//     // const [code, setCode] = useState('');
//     const [loading, setLoading] = useState(false);
//     const [copiedField, setCopiedField] = useState('');
//     const [error, setError] = useState('');
//     const responseRef = useRef(null);
//     const userName = localStorage.getItem('name') || 'there';

//     useEffect(() => {
//         if (responseRef.current) {
//             responseRef.current.scrollTop = 0;
//         }
//     }, [code]);

//     const handleOpen = () => {
//         setIsOpen(true);
//     };

//     const resetPopup = () => {
//         setPrompt('');
//         setCode('');
//         setError('');
//         setLoading(false);
//         setCopiedField('');
//     };



//     const handleGenerate = async () => {
//         const cleanPrompt = prompt.trim();

//         if (!cleanPrompt) {
//             setError('Prompt cannot be empty.');
//             return;
//         }

//         if (cleanPrompt.length < 10) {
//             setError('Please provide a more descriptive prompt.');
//             return;
//         }

//         if (cleanPrompt.length > 7000) {
//             setError('Prompt is too long. Please shorten it.');
//             return;
//         }

//         setError('');
//         setLoading(true);

//         const html = editor.getHtml();
//         const css = editor.getCss({ keepUnusedStyles: true });

//         // const requestData = {
//         //     prompt: `${cleanPrompt}\n\nCurrent HTML:\n${html}\n\nCSS:\n${css}`,
//         // };

//         const requestData = {
//   prompt: `
// You are working with a visual web editor.

// Please update the existing HTML and CSS based on this user request: "${cleanPrompt}"

// Make sure to:
// - Modify elements if they already exist (e.g., navbar, buttons, forms).
// - Avoid duplicating existing components.
// - Return only the updated HTML and CSS inside code blocks.

// Current HTML:
// ${html}

// Current CSS:
// ${css}
//   `.trim(),
// };


//         try {
//             const res = await axios.post(`${API_HOST}codeai/generate-code`, requestData);
//             setCode(res.data.code || '');
//             if (!res.data.code) setError('No code was returned. Try refining your prompt.');
//         } catch (err) {
//             setError('❌ Failed to generate code. Please try again.');
//         }

//         setLoading(false);
//     };


//     // function mergeAndInjectHtmlCss(editor, newHtml, newCss) {
//     //     const parser = new DOMParser();
//     //     const existingDom = parser.parseFromString(editor.getHtml(), 'text/html');
//     //     const newDom = parser.parseFromString(newHtml || '', 'text/html');

//     //     const existingBody = existingDom.body;
//     //     const newBody = newDom.body;

//     //     // Prevent injecting identical components
//     //     if (existingBody.innerHTML.trim() === newBody.innerHTML.trim()) {
//     //         console.log('No changes detected in HTML, skipping merge.');
//     //     } else {
//     //         Array.from(newBody.children).forEach((newEl) => {
//     //             const className = newEl.className?.split(' ')[0];
//     //             const id = newEl.id;

//     //             let match;
//     //             if (id) match = existingBody.querySelector(`#${id}`);
//     //             else if (className) match = existingBody.querySelector(`.${className}`);

//     //             if (match) match.replaceWith(newEl);
//     //             else existingBody.appendChild(newEl);
//     //         });

//     //         editor.setComponents(existingBody.innerHTML);
//     //     }

//     //     const existingCss = editor.getCss({ keepUnusedStyles: true });

//     //     // Normalize whitespace to compare
//     //     const normalize = str => str.replace(/\s+/g, '').trim();

//     //     if (normalize(existingCss) === normalize(newCss || '')) {
//     //         console.log('No changes detected in CSS, skipping merge.');
//     //     } else {
//     //         const finalCss = existingCss + `\n${newCss || ''}`;
//     //         editor.setStyle(finalCss);
//     //     }
//     // }

//     function mergeAndInjectHtmlCss(editor, newHtml, newCss) {
//     const parser = new DOMParser();
//     const existingDom = parser.parseFromString(editor.getHtml(), 'text/html');
//     const newDom = parser.parseFromString(newHtml || '', 'text/html');

//     const existingBody = existingDom.body;
//     const newBody = newDom.body;

//     // Normalize function to compare HTML/CSS
//     const normalize = (str) => str.replace(/\s+/g, ' ').trim();

//     const existingHTMLNorm = normalize(existingBody.innerHTML);
//     const newHTMLNorm = normalize(newBody.innerHTML);

//     if (existingHTMLNorm === newHTMLNorm) {
//         console.log('No changes detected in HTML, skipping merge.');
//     } else {
//         Array.from(newBody.children).forEach((newEl) => {
//             const tagName = newEl.tagName.toLowerCase();
//             const className = newEl.className?.split(' ')[0];
//             const id = newEl.id;

//             let match = null;
//             if (id) {
//                 match = existingBody.querySelector(`#${id}`);
//             } else if (className) {
//                 match = existingBody.querySelector(`.${className}`);
//             } else {
//                 match = existingBody.querySelector(tagName); // fallback by tag name
//             }

//             if (match) {
//                 match.replaceWith(newEl);
//             } else {
//                 // Avoid appending duplicates by tag
//                 const existingSameTag = Array.from(existingBody.children).find(
//                     (el) => el.tagName.toLowerCase() === tagName
//                 );
//                 if (existingSameTag) {
//                     existingSameTag.replaceWith(newEl);
//                 } else {
//                     existingBody.appendChild(newEl);
//                 }
//             }
//         });

//         editor.setComponents(existingBody.innerHTML);
//     }

//     const existingCss = editor.getCss({ keepUnusedStyles: true });
//     const newCssNormalized = normalize(newCss || '');

//     if (normalize(existingCss).includes(newCssNormalized)) {
//         console.log('No new CSS rules to add.');
//     } else {
//         const finalCss = existingCss + `\n${newCssNormalized}`;
//         editor.setStyle(finalCss);
//     }
// }



//     const handleInjectCode = () => {
//         if (!editor || !code.trim()) return;

//         const { html, css } = extractParts(code);
//         const hasValidCode = html || css;

//         if (!hasValidCode) {
//             setError('No valid code to inject.');
//             return;
//         }

//         mergeAndInjectHtmlCss(editor, html, css);

//         setIsOpen(false);
//         // resetPopup();
//     };

//     const copyToClipboard = (text, field) => {
//         navigator.clipboard.writeText(text).then(() => {
//             setCopiedField(field);
//             setTimeout(() => setCopiedField(''), 2000);
//         });
//     };


//     const extractParts = (rawCode) => {
//         let html = '';
//         let css = '';
//         let js = '';

//         const htmlMatches = [...rawCode.matchAll(/```html([\s\S]*?)```/g)];
//         const cssMatches = [...rawCode.matchAll(/```css([\s\S]*?)```/g)];
//         const jsMatches = [...rawCode.matchAll(/```(?:js|javascript)([\s\S]*?)```/g)];

//         // Fallback if no code blocks exist
//         const fallback = rawCode.trim();

//         // Extract from ``` blocks if available
//         html = htmlMatches.map(m => m[1].trim()).join('\n');
//         css = cssMatches.map(m => m[1].trim()).join('\n');
//         js = jsMatches.map(m => m[1].trim()).join('\n');

//         // 🛠 If no separate CSS block found, but HTML contains <style>
//         if (!css && html.includes('<style')) {
//             const parser = new DOMParser();
//             const doc = parser.parseFromString(`<body>${html}</body>`, 'text/html');

//             const styles = Array.from(doc.querySelectorAll('style'))
//                 .map(tag => tag.textContent.replace(/\/\*[\s\S]*?\*\//g, '')) // remove comments
//                 .join('\n');

//             css = styles.trim();

//             // Also remove style tags from the HTML
//             doc.querySelectorAll('style').forEach(tag => tag.remove());

//             html = doc.body.innerHTML.trim();
//         }

//         // If no ``` block was found at all, fallback
//         if (!html && !css && fallback.includes('<')) {
//             const parser = new DOMParser();
//             const doc = parser.parseFromString(`<body>${fallback}</body>`, 'text/html');

//             const styles = Array.from(doc.querySelectorAll('style'))
//                 .map(tag => tag.textContent.replace(/\/\*[\s\S]*?\*\//g, ''))
//                 .join('\n');

//             css = styles.trim();
//             doc.querySelectorAll('style').forEach(tag => tag.remove());

//             html = doc.body.innerHTML.trim();
//         }

//         return { html, css, js };
//     };


//     const getSafePreviewHTML = (rawCode) => {
//         const parts = extractParts(rawCode);
//         return `
//       <html>
//         <head>
//           <meta charset="UTF-8" />
//           <style>${parts.css}</style>
//         </head>
//         <body>
//           ${parts.html}
//           <script>${parts.js}</script>
//           <script>
//             document.addEventListener("DOMContentLoaded", () => {
//               document.querySelectorAll("a[href]").forEach(link => {
//                 link.addEventListener("click", e => {
//                   e.preventDefault();
//                   const href = link.getAttribute("href");
//                   if (href && !href.startsWith("#")) window.open(href, "_top");
//                 });
//               });
//             });
//           </script>
//         </body>
//       </html>
//     `;
//     };

//     const parts = extractParts(code);
//     const safePreviewHTML = getSafePreviewHTML(code);

//     return (
//         <>
//             <div className="ai-toggle-button" onClick={handleOpen}>✨</div>

//             {isOpen && (
//                 <div className="ai-modal">
//                     <div className="modal-overlay">
//                         <div className="modal-content">
//                             <button className="modal-close" onClick={() => setIsOpen(false)}>×</button>

//                             <div className="modal-header">
//                                 <div className="header-left">
//                                     <h2>✨ DSP AI ASSISTANT <span className="model-used">Model: Azure GPT 4</span></h2>
//                                 </div>
                                
//                             </div>

//                             <div className="response-section-wrapper">
//                                 <div className="response-section" ref={responseRef}>
//                                     {code ? (
//                                         <>
//                                             {['html', 'css', 'js'].map(
//                                                 (type) =>
//                                                     parts[type] && (
//                                                         <div key={type} className="code-block">
//                                                             <div className="code-header">
//                                                                 {type.toUpperCase()}
//                                                                 <button onClick={() => copyToClipboard(parts[type], type)}>
//                                                                     {copiedField === type ? 'Copied!' : 'Copy'}
//                                                                 </button>
//                                                             </div>
//                                                             <pre><code>{parts[type]}</code></pre>
//                                                         </div>
//                                                     )
//                                             )}
//                                             {safePreviewHTML && (
//                                                 <div className="preview-section">
//                                                     <h3>Live Preview</h3>
//                                                     <iframe
//                                                         srcDoc={safePreviewHTML}
//                                                         title="Live Preview"
//                                                         className="preview-frame"
//                                                     />
//                                                 </div>
//                                             )}
//                                             {error && <div className="error-message">{error}</div>}
//                                         </>
//                                     ) : (
//                                         <div className="greeting-message">
//                                             👋 Hey <strong>{userName}</strong>, Ready to dive in?
//                                             <br />
//                                             Start by describing what you want to build!
//                                             {error && <div className="error-message">{error}</div>}
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>

//                             <div className="input-area">
//                                 <div className="chat-input-container">
//                                     <textarea
//                                         placeholder="Type your request..."
//                                         value={prompt}
//                                         onChange={(e) => setPrompt(e.target.value)}
//                                         onKeyDown={(e) => {
//                                             if (e.key === 'Enter' && !e.shiftKey) {
//                                                 e.preventDefault();
//                                                 handleGenerate();
//                                             }
//                                         }}
//                                         disabled={loading}
//                                     />

//                                     <button
//                                         className="send-button"
//                                         onClick={handleGenerate}
//                                         disabled={loading}
//                                         title="Generate"
//                                     >
//                                         {loading ? (
//                                         <div className="spinner"></div>
//                                         ) : (
//                                         '➤'
//                                         )}
//                                     </button>
//                                 </div>
//                             </div>

//                             {code && (
//                                 <div className="action-buttons">
//                                     <button onClick={handleInjectCode} className="inject-button">Inject Code</button>
//                                     <button onClick={resetPopup} className="clear-button">Clear</button>
//                                 </div>
//                             )}

//                             <div className="disclaimer">
//                                 ⚠️ Generated code may require manual review or adjustment. Use with caution.
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </>
//     );
// }

// export default AiAssistantPopup;

import { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import { API_HOST } from '../../configs/api';
import './AiAssistantPopup.scss';

/**
 * The parent passes `editor` only; we manage prompt + chatHistory here.
 */
function AiAssistantPopup({ editor }) {
  const [isOpen, setIsOpen] = useState(false);

  const [prompt, setPrompt]           = useState('');
  const [chatHistory, setChatHistory] = useState([]);        // ← NEW
  const [loading, setLoading]         = useState(false);
  const [error,   setError]           = useState('');
  const [copiedField, setCopiedField] = useState('');

  const responseRef = useRef(null);
  const userName    = localStorage.getItem('name') || 'there';

  /* ────────────────────────── auto‑scroll chat */
  useEffect(() => {
    if (responseRef.current)
      responseRef.current.scrollTop = responseRef.current.scrollHeight;
  }, [chatHistory, isOpen]);

  /* ────────────────────────── open / close */
  const open   = () => setIsOpen(true);
  const close  = () => setIsOpen(false);

  /* ────────────────────────── send message */
  const handleGenerate = async () => {
    const clean = prompt.trim();
    if (!clean)           return setError('Prompt cannot be empty.');
    if (clean.length < 3) return setError('Prompt too short.');
    if (clean.length > 7_000) return setError('Prompt too long.');

    setError('');
    setLoading(true);

    // add USER message optimistically
    setChatHistory((h) => [...h, { role: 'user', text: clean }]);
    setPrompt('');                          // clear input immediately

    /* Current page context */
    const html = editor.getHtml();
    const css  = editor.getCss({ keepUnusedStyles: true });

    const req = {
      prompt: `
You are working with a visual web editor.

Please update the existing HTML and CSS based on this user request:

"${clean}"

Make sure to:
- Modify elements if they already exist (e.g., navbar, buttons, forms).
- Avoid duplicating existing components.
- Return ONLY the updated HTML and CSS inside code fences.

Current HTML:
${html}

Current CSS:
${css}`.trim(),
    };

    try {
      const { data } = await axios.post(`${API_HOST}codeai/generate-code`, req);
      const assistantText = data?.code || '⚠️ No reply.';
      setChatHistory((h) => [...h, { role: 'assistant', text: assistantText }]);
    } catch (e) {
      setChatHistory((h) => [...h, { role: 'assistant', text: '❌ Request failed.' }]);
    }
    setLoading(false);
  };

  /* ────────────────────────── latest assistant snippet for Inject */
  const latestAssistant = [...chatHistory].reverse()
    .find((m) => m.role === 'assistant')?.text || '';

  const { html: lastHtml, css: lastCss } = extractParts(latestAssistant);

  /* ────────────────────────── inject into GrapesJS */
  const handleInjectCode = () => {
    if (!lastHtml && !lastCss) return;
    mergeAndInjectHtmlCss(editor, lastHtml, lastCss);
    close();                        // keep chat in memory for next open
  };

  /* ────────────────────────── copy helper */
  const copy = (txt, field) => {
    navigator.clipboard.writeText(txt).then(() => {
      setCopiedField(field);
      setTimeout(() => setCopiedField(''), 2_000);
    });
  };

  /* ========== JSX  ===================================================== */
  return (
    <>
      <div className="ai-toggle-button" onClick={open}>✨</div>

      {isOpen && (
        <div className="ai-modal">
          <div className="modal-overlay">
            <div className="modal-content">
              <button className="modal-close" onClick={close}>×</button>

              {/* <header className="modal-header">
                <h6>✨ DSP AI ASSISTANT <span className="model-used">Azure GPT‑4</span></h6>
              </header> */}

              <header className="modal-header enhanced-header">
  <div className="header-left">
    <span className="sparkle">✨</span>
    <h6 className="title">DSP AI Assistant</h6>
  </div>
  <span className="model-used">🧠 Powered by Azure GPT‑4</span>
</header>


              {/* ─────── chat timeline ─────────────────────── */}
              <div className="response-section-wrapper" ref={responseRef}>
                {!chatHistory.length && (
                //   <div className="greeting-message">
                //     👋 Hi <strong>{userName}</strong>,<br/>
                //     Ask me to generate or tweak your HTML/CSS!
                //   </div>
                                        <div className="greeting-message">
                                             👋 Hey <strong>{userName}</strong>, Ready to dive in?
                                             <br />
                                             Start by describing what you want to build!

                                        </div>
                )}

                {/* {chatHistory.map((m, idx) => (
                  <ChatBubble
                    key={idx}
                    message={m}
                    copy={copy}
                    copiedField={copiedField}
                  />
                ))} */}
                {chatHistory.map((m, idx) => (
  <ChatBubble
    key={idx}
    message={m}
    copy={copy}
    copiedField={copiedField}
    isLatestAssistant={
      m.role === 'assistant' &&
      chatHistory.slice(idx + 1).every(msg => msg.role !== 'assistant')
    }
  />
))}

              </div>

              {/* ─────── composer ─────────────────────────── */}
                {error && <div className="error-message">{error}</div>}
              <div className="input-area">
                <div className="chat-input-container">
                  <textarea
                    placeholder="Type your request..."
                    value={prompt}
                    onChange={(e) => setPrompt(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && !e.shiftKey) {
                        e.preventDefault();
                        handleGenerate();
                      }
                    }}
                    disabled={loading}
                  />
                  <button
                    className="send-button"
                    onClick={handleGenerate}
                    disabled={loading}
                    title="Send"
                  >
                    {loading ? <div className="spinner" /> : '➤'}
                  </button>
                </div>
              </div>

              {/* ─────── actions for latest assistant message ─*/}
              {latestAssistant && (
                <div className="action-buttons">
                  <button onClick={handleInjectCode} className="inject-button">
                    Inject Code
                  </button>
                  <button onClick={() => setChatHistory([])} className="clear-button">
                    Clear Chat
                  </button>
                </div>
              )}

              <footer className="disclaimer">
                ⚠️ Generated code may need manual review.
              </footer>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

/* -----------------------------------------------------------------------
   ChatBubble component (tiny helper)
------------------------------------------------------------------------ */
// function ChatBubble({ message, copy, copiedField }) {
//   const { role, text } = message;
//   const { html, css, js } = extractParts(text);

//   const isAssistant = role === 'assistant';

//   if (!isAssistant) {
//     return <div className="bubble user">{text}</div>;
//   }

//   /* Assistant bubble renders code blocks + preview like before */
//   return (
//     <div className="bubble assistant">
//       {['html', 'css', 'js'].map(
//         (type) =>
//           ({ html, css, js }[type] && (
//             <div key={type} className="code-block">
//               <div className="code-header">
//                 {type.toUpperCase()}
//                 <button onClick={() => copy({ html, css, js }[type], type)}>
//                   {copiedField === type ? 'Copied!' : 'Copy'}
//                 </button>
//               </div>
//               <pre><code>{({ html, css, js }[type])}</code></pre>
//             </div>
//           ))
//       )}
//     </div>
//   );
// }

function ChatBubble({ message, copy, copiedField, isLatestAssistant }) {
  const { role, text } = message;
  const { html, css, js } = extractParts(text);

  if (role !== 'assistant') {
    return <div className="bubble user">{text}</div>;
  }

  const getPreviewHTML = () => `
    <html>
      <head>
        <style>${css}</style>
      </head>
      <body>
        ${html}
        <script>${js}</script>
        <script>
          document.querySelectorAll("a[href]").forEach(link => {
            link.addEventListener("click", e => {
              e.preventDefault();
              const href = link.getAttribute("href");
              if (href && !href.startsWith("#")) window.open(href, "_top");
            });
          });
        </script>
      </body>
    </html>
  `;

  return (
    <div className="bubble assistant">
      {['html', 'css', 'js'].map(
        (type) =>
          ({ html, css, js }[type] && (
            <div key={type} className="code-block">
              <div className="code-header">
                {type.toUpperCase()}
                <button onClick={() => copy({ html, css, js }[type], type)}>
                  {copiedField === type ? 'Copied!' : 'Copy'}
                </button>
              </div>
              <pre><code>{({ html, css, js }[type])}</code></pre>
            </div>
          ))
      )}

      {/* Only for the latest assistant response */}
      {isLatestAssistant && html && (
        <div className="preview-section">
          <h3>Live Preview</h3>
          <iframe
            srcDoc={getPreviewHTML()}
            title="Live Preview"
            className="preview-frame"
          />
        </div>
      )}
    </div>
  );
}


/* -----------------------------------------------------------------------
   Helpers (your old ones, unchanged)
------------------------------------------------------------------------ */
//function extractParts(raw) { /* … exactly your existing code … */ }

const extractParts = (rawCode) => {
        let html = '';
        let css = '';
        let js = '';

        const htmlMatches = [...rawCode.matchAll(/```html([\s\S]*?)```/g)];
        const cssMatches = [...rawCode.matchAll(/```css([\s\S]*?)```/g)];
        const jsMatches = [...rawCode.matchAll(/```(?:js|javascript)([\s\S]*?)```/g)];

        // Fallback if no code blocks exist
        const fallback = rawCode.trim();

        // Extract from ``` blocks if available
        html = htmlMatches.map(m => m[1].trim()).join('\n');
        css = cssMatches.map(m => m[1].trim()).join('\n');
        js = jsMatches.map(m => m[1].trim()).join('\n');

        // 🛠 If no separate CSS block found, but HTML contains <style>
        if (!css && html.includes('<style')) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(`<body>${html}</body>`, 'text/html');

            const styles = Array.from(doc.querySelectorAll('style'))
                .map(tag => tag.textContent.replace(/\/\*[\s\S]*?\*\//g, '')) // remove comments
                .join('\n');

            css = styles.trim();

            // Also remove style tags from the HTML
            doc.querySelectorAll('style').forEach(tag => tag.remove());

            html = doc.body.innerHTML.trim();
        }

        // If no ``` block was found at all, fallback
        if (!html && !css && fallback.includes('<')) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(`<body>${fallback}</body>`, 'text/html');

            const styles = Array.from(doc.querySelectorAll('style'))
                .map(tag => tag.textContent.replace(/\/\*[\s\S]*?\*\//g, ''))
                .join('\n');

            css = styles.trim();
            doc.querySelectorAll('style').forEach(tag => tag.remove());

            html = doc.body.innerHTML.trim();
        }

        return { html, css, js };
    };

//function mergeAndInjectHtmlCss(editor, newHtml, newCss) { /* … unchanged … */ }

 function mergeAndInjectHtmlCss(editor, newHtml, newCss) {
    const parser = new DOMParser();
    const existingDom = parser.parseFromString(editor.getHtml(), 'text/html');
    const newDom = parser.parseFromString(newHtml || '', 'text/html');

    const existingBody = existingDom.body;
    const newBody = newDom.body;

    // Normalize function to compare HTML/CSS
    const normalize = (str) => str.replace(/\s+/g, ' ').trim();

    const existingHTMLNorm = normalize(existingBody.innerHTML);
    const newHTMLNorm = normalize(newBody.innerHTML);

    if (existingHTMLNorm === newHTMLNorm) {
        console.log('No changes detected in HTML, skipping merge.');
    } else {
        Array.from(newBody.children).forEach((newEl) => {
            const tagName = newEl.tagName.toLowerCase();
            const className = newEl.className?.split(' ')[0];
            const id = newEl.id;

            let match = null;
            if (id) {
                match = existingBody.querySelector(`#${id}`);
            } else if (className) {
                match = existingBody.querySelector(`.${className}`);
            } else {
                match = existingBody.querySelector(tagName); // fallback by tag name
            }

            if (match) {
                match.replaceWith(newEl);
            } else {
                // Avoid appending duplicates by tag
                const existingSameTag = Array.from(existingBody.children).find(
                    (el) => el.tagName.toLowerCase() === tagName
                );
                if (existingSameTag) {
                    existingSameTag.replaceWith(newEl);
                } else {
                    existingBody.appendChild(newEl);
                }
            }
        });

        editor.setComponents(existingBody.innerHTML);
    }

    const existingCss = editor.getCss({ keepUnusedStyles: true });
    const newCssNormalized = normalize(newCss || '');

    if (normalize(existingCss).includes(newCssNormalized)) {
        console.log('No new CSS rules to add.');
    } else {
        const finalCss = existingCss + `\n${newCssNormalized}`;
        editor.setStyle(finalCss);
    }
}

export default AiAssistantPopup;


